import { render } from "./SelectBox.vue?vue&type=template&id=4bb55154&scoped=true&ts=true&lang=pug"
import script from "./SelectBox.vue?vue&type=script&lang=ts"
export * from "./SelectBox.vue?vue&type=script&lang=ts"

import "./SelectBox.vue?vue&type=style&index=0&id=4bb55154&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb55154"]])

export default __exports__